export const PAGE_CONTENT_KEY = "page-contents"
export const DIR_CONTENT_KEY = "dir-contents"
export const DIR_SECOND_LEVEL_DIRECTORIES_KEY = "dir-second-level-directories"
export const THIRD_NAV_CONTENT_KEY = "third-nav-contents"
export const CSP_CONTENT_KEY = "csp-contents"
export const NAVIGATION_CONTENT_KEY = "navigation-contents"
export const RESOURCE_CATEGORY_CONTENT_KEY = "resource-category-contents"
export const RESOURCE_ROOM_NAME_KEY = "resource-room-name"
export const RESOURCE_ROOM_CONTENT_KEY = "resource-room-contents"
export const FOLDERS_CONTENT_KEY = "folders-contents"
export const LAST_UPDATED_KEY = "last-updated"
export const MEDIA_CONTENT_KEY = "media-contents"
export const MEDIA_MULTIPLE_CONTENT_KEY = "media-multiple-contents"
export const IMAGE_DETAILS_KEY = "image-details"
export const DOCUMENT_DETAILS_KEY = "document-details"
export const SETTINGS_CONTENT_KEY = "settings-content"
export const SITES_IS_PRIVATE_KEY = "sites-is-private"
export const SITE_COLORS_KEY = "site-colors"
export const SITE_URL_KEY = "isomercms_site_url"
export const STAGING_URL_KEY = "isomercms_staging_url"
export const SITE_DASHBOARD_INFO_KEY = "site-dashboard-info"
export const SITE_DASHBOARD_REVIEW_REQUEST_KEY = "site-dashboard-review-request"
export const SITE_DASHBOARD_COLLABORATORS_KEY = "site-dashboard-collaborators"
export const SITE_DASHBOARD_LAUNCH_STATUS_KEY = "site-dashboard-launch-status"
export const SITE_LINK_CHECKER_STATUS_KEY = "site-link-checker-status"
export const NOTIFICATIONS_KEY = "notifications-content"
export const ALL_NOTIFICATIONS_KEY = "all-notifications"
export const LIST_COLLABORATORS_KEY = "list-collaborators"
export const GET_COLLABORATOR_ROLE_KEY = "get-collaborator-role"
export const DIFF_QUERY_KEY = "diff"
export const REVIEW_REQUEST_QUERY_KEY = "review-request"
export const COMMENTS_KEY = "comments-content"
export const ALL_SITES_KEY = "all-sites-content"
export const SITE_PREVIEW_KEY = "site-previews"
export const GET_HOMEPAGE_KEY = "get-homepage"
export const GET_ALL_COLLECTIONS_KEY = "get-all-collections"
export const GET_CONTACT_US_KEY = "get-contact-us"
export const GITHUB_BLOB_QUERY_KEY = "github-blob"
export const LIST_MEDIA_DIRECTORY_FILES_KEY = "list-media-directory-files"
export const LIST_MEDIA_FOLDERS_KEY = "list-media-folders"
export const LIST_ALL_MEDIA_KEY = "list-all-media"
export const GET_ALL_MEDIA_FILES_KEY = "get-all-media-files"
export const SGID_QUERY_KEY = "verify-sgid"
export const GET_STAGING_BUILD_STATUS_KEY = "get-staging-build-status"
